/*
 * SILVER GARDENS - UNIVERSAL ADD-TO-CART DRAWER OPEN
 * Works with Stiletto native forms and SG configurators.
 * Only responds to confirmed additions, not linked-cart edits.
 * Keeps Stiletto responsible for opening and refreshing its drawer.
 */
(function () {
  if (window.SGCartAutoOpenInstalled) return;
  window.SGCartAutoOpenInstalled = true;

  var pending = false;
  var timer = null;
  var observer = null;

  function drawer() {
    return document.querySelector('.quick-cart[data-section-type="quick-cart"]');
  }

  function isOpen() {
    var cart = drawer();
    if (!cart) return false;
    var wrapper = cart.querySelector('.quick-cart__wrapper');
    return (
      cart.classList.contains('active') ||
      cart.classList.contains('is-open') ||
      (wrapper && (
        wrapper.classList.contains('active') ||
        wrapper.classList.contains('is-open')
      ))
    );
  }

  function clearPending() {
    pending = false;
    if (timer !== null) {
      window.clearTimeout(timer);
      timer = null;
    }
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function openNativeCart() {
    if (!pending) return;
    if (isOpen()) {
      clearPending();
      return;
    }
    var icon = document.querySelector('a[data-js-cart-icon]');
    var available = !!(drawer() && document.querySelector('.quick-cart__wrapper'));
    clearPending();

    // Clicking Stiletto's own cart icon invokes its normal drawer,
    // focus management and close controls; never imitate those states.
    if (available && icon) icon.click();
  }

  function requestOpen() {
    if (!drawer() || isOpen()) return;
    if (pending) return;
    pending = true;

    // Stiletto refreshes the drawer asynchronously after the AJAX add.
    // Prefer to open after refreshed content replaces the previous items.
    var content = drawer().querySelector('.quick-cart__container');
    if (content && typeof MutationObserver !== 'undefined') {
      observer = new MutationObserver(function (changes) {
        if (!pending) return;
        var refreshed = changes.some(function (change) {
          return change.type === 'childList' &&
            (change.addedNodes.length || change.removedNodes.length);
        });
        if (refreshed) window.requestAnimationFrame(openNativeCart);
      });
      observer.observe(content, { childList: true, subtree: true });
    }

    // Fallback if the theme refresh emits no cart event or DOM mutation.
    timer = window.setTimeout(openNativeCart, 1400);
  }

  // Custom SG plant, bundle, mini collection and quiz additions.
  document.addEventListener('apps:product-added-to-cart', function (event) {
    if (event.detail && event.detail.source === 'configured-cart') return;
    requestOpen();
  });

  // Stiletto's normal product and pot Add to Cart forms.
  document.addEventListener('cart:item-added', requestOpen);

  // When the refreshed cart arrives, do not hold up the customer.
  document.addEventListener('cart:updated', function () {
    if (pending) window.requestAnimationFrame(openNativeCart);
  });

  // Avoid toggling or re-opening an already-open cart.
  document.addEventListener('quick-cart:open', clearPending);

  // Quiz adds use their own success event. Refresh the Stiletto drawer
  // first; the normal SG add-event listener above then schedules opening.
  document.addEventListener('sg:cart-added', function () {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', {
      detail: { source: 'silver-gardens-plant-quiz' }
    }));
  });

  // Never reopen on linked quantity edits or item removals.
  // Those emit cart:updated, but do not set the pending-add flag.
})();